var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIOutpatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.905 11.078c2.871 0.225 5.387-1.919 5.616-4.789 0.223-2.875-1.926-5.389-4.796-5.616-2.871-0.227-5.385 1.919-5.614 4.792-0.224 2.875 1.917 5.385 4.794 5.614z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.336 21.539c1.628 0.305 2.852 1.744 2.852 3.464 0 1.948-1.58 3.528-3.528 3.528h-11.432c-1.236 0-2.239-1.002-2.239-2.239 0-0.301 0.059-0.587 0.165-0.849l1.236-2.885 13.766-9.86h-6.559c-2.519-0.070-4.289 0.805-5.304 2.789-0.688 1.335-4.342 9.498-4.342 9.498-0.16 0.404-0.25 0.845-0.25 1.308 0 1.948 1.579 3.528 3.528 3.528h4.465l-1.317 8.66-6.93 20.026c-0.583 1.777 0.382 3.671 2.143 4.259 1.764 0.589 3.676-0.378 4.259-2.146l7.969-22.59c1.554 2.525 4.647 7.051 5.173 7.906 0.121 1.421 1.234 13.948 1.234 13.948 0.169 1.862 1.806 3.219 3.657 3.059 1.853-0.158 3.225-1.803 3.059-3.657l-1.31-14.743c-0.044-0.524-0.214-1.028-0.49-1.471l-5.729-9.285 0.912-11.653c0 0 1.357 4.611 1.458 4.944 0.291 0.952 0.947 1.635 1.62 2.18 0.394 0.314 7.081 4.865 7.081 4.865 0.372 0.172 0.676 0.323 1.075 0.35 1.293 0.106 2.429-0.861 2.533-2.158 0.064-0.831-0.307-1.588-0.92-2.061 0 0-6.663-4.575-6.934-4.774-0.221-0.167-0.395-0.458-0.439-0.61l-2.637-9.498c-0.429-1.437-1.877-2.673-3.708-2.673h-0.789l-3.329 8.841z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.66 27.241c1.236 0 2.239-1.002 2.239-2.239 0-1.154-0.878-2.093-1.999-2.214l-1.635 4.467 1.395-0.014z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOutpatient);
export default __webpack_public_path__ + "static/media/i-outpatient.2af1ed6d.svg";
export { ForwardRef as ReactComponent };